import { Progress as AntProgress } from 'antd';
import { ProgressProps as AntProgressProps } from 'antd/es/progress';

export type ProgressProps = {
  // TODO
};

const Progress = (props: ProgressProps & AntProgressProps) => {
  return <AntProgress {...props} className="progress" />;
};

Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  strokeLinecap: 'round',
};

export default Progress;
